import React from "react";
import {useNavigate} from "react-router-dom";
import addToCard from "../../../../cookieStorage/addToCard";

function ProductCardShort(props) {

    const navigate = useNavigate();

    const product = {
        id: props.productID,
        name: props.name,
        price: props.price,
        image: props.image,
        description: props.description,
        quantity: 1
    };

    return (

            <div className="product-card bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
                <div className="relative h-72 overflow-hidden" onClick={() => navigate(`/products/productpage/${props.productID}`)}>
                    {/*<span className="absolute top-3 right-3 bg-red-500 text-white text-xs px-3 py-1 rounded-full z-10">-25%</span>*/}
                    <img
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        src={props.image}
                        alt={props.name}/>
                </div>
                <div className="p-4">
                    <h3 className="text-lg font-serif font-semibold text-brand-green mb-2">{props.name}</h3>
                    <p className="text-sm text-gray-500 mb-2">
                        {props.description}
                    </p>
                    <div className="flex text-yellow-400 text-sm mb-2">
                        {/*<i className="fa-solid fa-star"></i>*/}
                        {/*<i className="fa-solid fa-star"></i>*/}
                        {/*<i className="fa-solid fa-star"></i>*/}
                        {/*<i className="fa-solid fa-star"></i>*/}
                        {/*<i className="fa-solid fa-star-half-stroke"></i>*/}
                        {/*<span className="text-gray-500 ml-2">{props.rating}</span>*/}
                    </div>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-xl font-bold text-brand-green">€{props.price}</span>
                            {/*<span className="text-sm text-gray-400 line-through ml-2">€60.00</span>*/}
                        </div>
                        {/*<button onClick={()=> addToCard(product,1)}
                            className="bg-custom-green text-white p-2 rounded-lg hover:bg-opacity-90"><i
                            className="fa-solid fa-cart-plus"></i></button>*/}
                    </div>
                </div>
            </div>
    );

}

export default ProductCardShort;